// MpButton — botão do padrão visual MPires (reutilizável, não substitui
// nenhum botão existente). Tamanhos P 32 / M 36 / G 44 px; tipos primary,
// secondary, tertiary, destructive. Ícone opcional à esquerda (16 px).
import React from "react";
import { colors, radii } from "./tokens";

const SIZE_PX = { P: 32, M: 36, G: 44 };

export default function MpButton({
  size = "M",
  type = "primary",
  icon: Icon,
  children,
  disabled = false,
  onClick,
  "aria-label": ariaLabel,
  testId,
  style: extraStyle,
  ...rest
}) {
  const h = SIZE_PX[size] || SIZE_PX.M;
  const base = {
    height: h,
    padding: `0 ${h >= 44 ? 16 : 12}px`,
    borderRadius: radii.botao,
    fontSize: 14,
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    transition: "background-color 120ms ease, border-color 120ms ease, color 120ms ease",
    border: "1px solid transparent",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
  };
  const byType = {
    primary:     { background: colors.primaria, color: colors.branco,   borderColor: colors.primaria },
    secondary:   { background: colors.branco,   color: colors.primaria, borderColor: colors.neutro[300] },
    tertiary:    { background: "transparent",   color: colors.primaria, borderColor: "transparent" },
    destructive: { background: colors.branco,   color: colors.vermelho, borderColor: colors.vermelho },
  };
  const style = { ...base, ...(byType[type] || byType.primary), ...(extraStyle || {}) };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      style={style}
      {...rest}
    >
      {Icon ? <Icon width={16} height={16} /> : null}
      {children ? <span>{children}</span> : null}
    </button>
  );
}
